// OWNER: HELP. One help article. Deep links to sections work: /help/rules#dispatch.
import { createFileRoute } from '@tanstack/react-router'
import { HelpArticlePage } from '@/help/HelpArticlePage'
import { ArticleCrumb } from '@/help/ArticleCrumb'

export const Route = createFileRoute('/help/$slug')({
  staticData: { crumb: ArticleCrumb },
  component: HelpArticleRoute,
})

function HelpArticleRoute() {
  const { slug } = Route.useParams()
  return <HelpArticlePage key={slug} slug={slug} />
}
